import gql from 'graphql-tag';

export default gql`
  mutation createOneLessonTemplateMutation(
    $title: String!
    $isNewTemplate: Boolean
    $course: MongoID!
    $courseCategory: MongoID!
    $student: MongoID
    $isTeacherLessonTemplate: Boolean
    $isPersonalLessonTemplate: Boolean
  ) {
    createOneLessonTemplateMutation(
      title: $title
      isNewTemplate: $isNewTemplate
      course: $course
      courseCategory: $courseCategory
      student: $student
      isTeacherLessonTemplate: $isTeacherLessonTemplate
      isPersonalLessonTemplate: $isPersonalLessonTemplate
    ) {
      record {
        title
        _id
        createdAt
      }
    }
  }
`;
